export default __webpack_public_path__ + "static/media/custoBeneficio.97dff9c4.png";